import { render } from "./TheCursor.vue?vue&type=template&id=440dd667&scoped=true"
const script = {}

import "./TheCursor.vue?vue&type=style&index=0&id=440dd667&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-440dd667"]])

export default __exports__